@if (loading()) {
  <p class="placeholder-text">Loading...</p>
} @else if (fields().length > 0) {
  <div class="field-display-grid">
    @for (field of fields(); track field.label) {
      <div class="info-item">
        <span class="info-label">{{ field.label }}</span>
        @if (field.value) {
          <span class="info-value">{{ field.value }}</span>
        } @else {
          <span class="info-value info-value--not-provided">Not provided</span>
        }
      </div>
    }
  </div>
} @else {
  <p class="placeholder-text">No data available</p>
}
